var render = function render(){var _vm=this,_c=_vm._self._c;return _c('post-layout',{attrs:{"tab-index":_vm.tabIndex,"posts":_vm.posts},scopedSlots:_vm._u([(Object.keys(_vm.post).length)?{key:"content",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.post.content)}})]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }